import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _05567e1e = () => interopDefault(import('../pages/adasok/index.vue' /* webpackChunkName: "pages/adasok/index" */))
const _9115750c = () => interopDefault(import('../pages/kereses.vue' /* webpackChunkName: "pages/kereses" */))
const _5083fafa = () => interopDefault(import('../pages/munkatarsak.vue' /* webpackChunkName: "pages/munkatarsak" */))
const _fd1df3da = () => interopDefault(import('../pages/musorok/index.vue' /* webpackChunkName: "pages/musorok/index" */))
const _01fccdf5 = () => interopDefault(import('../pages/musorvezetok/index.vue' /* webpackChunkName: "pages/musorvezetok/index" */))
const _1eff328b = () => interopDefault(import('../pages/player.vue' /* webpackChunkName: "pages/player" */))
const _66e1c708 = () => interopDefault(import('../pages/playlist.vue' /* webpackChunkName: "pages/playlist" */))
const _25bdee80 = () => interopDefault(import('../pages/adasok/_adas.vue' /* webpackChunkName: "pages/adasok/_adas" */))
const _4c5a067e = () => interopDefault(import('../pages/musorok/_musor.vue' /* webpackChunkName: "pages/musorok/_musor" */))
const _4a13f91e = () => interopDefault(import('../pages/musorvezetok/_musorvezeto.vue' /* webpackChunkName: "pages/musorvezetok/_musorvezeto" */))
const _877c2ad0 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _8ae96d60 = () => interopDefault(import('../pages/_slug.vue' /* webpackChunkName: "pages/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/adasok",
    component: _05567e1e,
    name: "adasok"
  }, {
    path: "/kereses",
    component: _9115750c,
    name: "kereses"
  }, {
    path: "/munkatarsak",
    component: _5083fafa,
    name: "munkatarsak"
  }, {
    path: "/musorok",
    component: _fd1df3da,
    name: "musorok"
  }, {
    path: "/musorvezetok",
    component: _01fccdf5,
    name: "musorvezetok"
  }, {
    path: "/player",
    component: _1eff328b,
    name: "player"
  }, {
    path: "/playlist",
    component: _66e1c708,
    name: "playlist"
  }, {
    path: "/adasok/:adas",
    component: _25bdee80,
    name: "adasok-adas"
  }, {
    path: "/musorok/:musor",
    component: _4c5a067e,
    name: "musorok-musor"
  }, {
    path: "/musorvezetok/:musorvezeto",
    component: _4a13f91e,
    name: "musorvezetok-musorvezeto"
  }, {
    path: "/",
    component: _877c2ad0,
    name: "index"
  }, {
    path: "/:slug",
    component: _8ae96d60,
    name: "slug"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
